var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Menu'),_c('TheSlider'),_c('AfterSlider'),_c('actualites'),_c('rayons'),_c('selections'),_c('promos'),_c('BeforeFooter'),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }